import React from 'react';
import { observer } from 'mobx-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStore } from '../store/useStore';

/** 管理端登录守卫：未登录跳转 `/devops/creator-outreach/login`。 */
export default observer(function AdminAuthRoute({ children }: { children: JSX.Element }) {
  const { adminLoginStore } = useStore();
  const location = useLocation();

  if (adminLoginStore.data.hasLogin) {
    return children;
  }
  return <Navigate to='/devops/creator-outreach/login' state={{ from: location }} replace />;
});
